/**
 * Opens external links in a new tab and adds rel="noopener noreferrer".
 * Re-processes dynamically injected content (cart drawer, search, etc.).
 */
(function () {
  const PROCESSED_ATTR = 'data-external-link-processed';
  const SKIP_PROTOCOLS = /^(mailto:|tel:|javascript:|#)/i;
  const SHOPIFY_HOST_SUFFIXES = ['shopify.com', 'myshopify.com', 'shop.app'];

  function isShopifyHost(hostname) {
    const host = hostname.toLowerCase();
    return SHOPIFY_HOST_SUFFIXES.some(
      (suffix) => host === suffix || host.endsWith('.' + suffix)
    );
  }

  function getInternalHosts() {
    const hosts = new Set([window.location.hostname]);

    if (window.shopUrl) {
      try {
        hosts.add(new URL(window.shopUrl).hostname);
      } catch (error) {
        /* ignore invalid shopUrl */
      }
    }

    return hosts;
  }

  function isExternalLink(anchor) {
    const href = anchor.getAttribute('href');
    if (!href || SKIP_PROTOCOLS.test(href.trim())) return false;

    try {
      const url = new URL(href.trim(), window.location.href);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return false;
      if (isShopifyHost(url.hostname)) return false;
      return !getInternalHosts().has(url.hostname);
    } catch (error) {
      return false;
    }
  }

  function setRelNoopener(anchor) {
    const relValues = new Set(
      (anchor.getAttribute('rel') || '')
        .split(/\s+/)
        .map((value) => value.trim())
        .filter(Boolean)
    );

    relValues.add('noopener');
    relValues.add('noreferrer');
    anchor.setAttribute('rel', Array.from(relValues).join(' '));
  }

  function processAnchor(anchor) {
    if (anchor.hasAttribute(PROCESSED_ATTR) || anchor.hasAttribute('data-keep-same-window')) {
      return;
    }

    anchor.setAttribute(PROCESSED_ATTR, '');

    if (!isExternalLink(anchor)) return;

    anchor.setAttribute('target', '_blank');
    setRelNoopener(anchor);
  }

  function processLinks(root) {
    root.querySelectorAll('a[href]').forEach(processAnchor);
  }

  function init() {
    processLinks(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches?.('a[href]')) processAnchor(node);
          processLinks(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
